<template>
  <v-expansion-panel v-model="panel" expand>
    <v-expansion-panel-content
      v-if="quote.quoteAnswers && quote.quoteAnswers.length"
    >
      <template v-slot:header>
        <h2><v-icon>check_circle</v-icon>Answers</h2>
      </template>
      <v-card>
        <v-card-text>
          <table border="1">
            <tr>
              <th>Body</th>
              <th>Value</th>
            </tr>
            <tr v-for="quoteAnswer in quote.quoteAnswers" :key="quoteAnswer.id">
              <td>
                <span v-if="quoteAnswer.question">{{
                  quoteAnswer.question.body
                }}</span>
              </td>
              <td>
                <span v-if="quoteAnswer.value != null">{{
                  quoteAnswer.value
                }}</span>
                <span v-if="quoteAnswer.questionTypeOption">{{
                  quoteAnswer.questionTypeOption.value
                }}</span>
              </td>
            </tr>
          </table>
          <v-btn :to="{ name: 'evaluateQuote', params: { id: quote.id } }"
            >Evaluate</v-btn
          >
          <v-btn
            :to="{ name: 'promotion', params: { id: promotion.id } }"
            v-if="promotion"
            >{{ `Promotion: ${promotion.body}` }}</v-btn
          >
        </v-card-text>
      </v-card>
    </v-expansion-panel-content>
  </v-expansion-panel>
</template>

<script>
import nbmlaw from "@/api/nbmlaw";
export default {
  name: "Answer",
  props: ["quote", "lastUpdated", "selectedHeaderElement"],
  data() {
    return {
      promotion: null,
      panel: [false]
    };
  },
  methods: {
    async fetchPromotion() {
      if (this.quote.promotionid) {
        const response = await nbmlaw.get(
          `/cors/admin/sales/promotions/${this.quote.promotionid}`
        );
        // console.log(response.data);
        this.promotion = response.data;
      }
    }
  },
  watch: {
    lastUpdated: {
      immediate: true,
      handler() {
        this.fetchPromotion();
      }
    }
  }
};
</script>